import { athletesOf, isMultiSchool } from './championDisplay.js'
const text = value => typeof value === 'string' ? value.trim() : ''
/** Display-only recorded claims. Never winner verification or account authority. */
export function recordedChampionFacts(record) {
  if (!record || record.sourceType) return { applicable: false, claims: [], members: [], note: '' }
  const raw = record.raw || record
  const claims = record.isIndyGroup ? [] : [...new Set([record.champion, record.current_champion, raw.current_champion,
    record.winningSchool, record.sr_winning_school, raw.sr_winning_school].map(text).filter(Boolean))]
  const refs = athletesOf({...raw,...record})
  const members = refs.ok ? refs.lines.map(row => [row.athlete, row.school, row.event].map(text).filter(Boolean).join(' · ')).filter(Boolean) : []
  const split = record.splitFamily?.role === 'parent' || (record.championSearchTag || record.sr_champion_search || raw.sr_champion_search) === 'split_into_divisions'
  const note = record.isIndyGroup ? 'Synthetic individual grouping; names below are member references, not one champion of this grouping.'
    : split ? 'Container claim only; review actual child records. Not one verified winner.'
    : isMultiSchool({...raw,...record}) ? 'Multiple-school record; these claims do not establish a single verified winner.'
      : 'Recorded claim; verify the result and its source before use.'
  return { applicable: true, claims, members, note, referencesError: refs.ok ? '' : 'Recorded member references are unreadable; review the source record.' }
}
export function recordedChampionText(record) {
  const facts = recordedChampionFacts(record)
  return facts.applicable ? [...facts.claims, ...facts.members].join(' · ') || 'No champion name recorded' : ''
}
